const STORAGE_KEYS = {
    TOKEN: 'TOKEN_USUARIO',
    USUARIO: 'USUARIO',
    TIPO: 'TIPO_USUARIO'
};

export function loginAuth(token, usuario, tipo) {
    try {
        const userObject = typeof usuario === 'object' && !Array.isArray(usuario) && usuario !== null
            ? usuario
            : {};

        localStorage.setItem(STORAGE_KEYS.TOKEN, token);
        localStorage.setItem(STORAGE_KEYS.USUARIO, JSON.stringify(userObject));
        localStorage.setItem(STORAGE_KEYS.TIPO, tipo);
    } catch (error) {
        console.error('Error saving user to localStorage:', error);
        throw error; // Opcional: para manejar el error en el componente
    }
}

export function logoutAuth() {
    localStorage.removeItem(STORAGE_KEYS.TOKEN);
    localStorage.removeItem(STORAGE_KEYS.USUARIO);
    localStorage.removeItem(STORAGE_KEYS.TIPO);
}

export function isLogin() {
    const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
    return !!token; // Devuelve true solo si existe y no está vacío
}

export function obtenerTipoUsuario() {
    return localStorage.getItem(STORAGE_KEYS.TIPO) || null;
}

export function obtenerUsuario() {
    try {
        const userData = localStorage.getItem(STORAGE_KEYS.USUARIO);
        if (!userData) return null;

        const parsed = JSON.parse(userData);
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
            ? parsed
            : null;
    } catch (error) {
        console.error('Error reading user from localStorage:', error);
        return null;
    }
}